import type { QuestionChoiceType, QuestionRankingModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'

type Props = {
  question: Question
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'ranking'
 */
export function SurveyQuestionAnswerRanking({ question }: Props) {
  const modelData = question.toJSON() as QuestionRankingModelData
  const value = question.value as string[]

  return (
    <>
      {value.map((choiceValue, index) => {
        const choice = modelData.choices.find((c: QuestionChoiceType) =>
          typeof c === 'string' ? c === choiceValue : c.value === choiceValue,
        )
        const displayText = typeof choice === 'string' ? choice : choice?.text || choiceValue
        return (
          <div key={choiceValue}>
            {`${index + 1}:${displayText}`}
          </div>
        )
      })}
      {modelData.showCommentArea && question.comment.length > 0 && <div className="mt-2">{question.comment}</div>}
    </>
  )
}
